import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { EditCompanyPanelBaseDataProvider } from '../dataProvider/EditCompanyPanelBaseDataProvider';
import { EditCompanyPanelDataProviderFactory } from '../factory/EditCompanyPanelDataProviderFactory';
import { CompanyData } from '../../../types/company-data';

export class EditCompanyPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EditCompanyPanelDataProviderFactory;
  public dataProvider: EditCompanyPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new EditCompanyPanelDataProviderFactory(),
    });
  }

  public async getManagedCompanyById(companyId: string): Promise<CompanyData> {
    return this.dataProvider.getManagedCompanyById(companyId);
  }
}
